import { allDialogueIds, dialogueLinesById, DIALOGUE_LINES, type DialogueLine } from "../data/dialogueData.js";
import { t } from "../i18n/i18n.js";
import type { BattleDialogueData } from "./battleDialogueTypes.js";

export interface RecordDialogueCardData {
  readonly dialogueId: string;
  readonly title: string;
  readonly triggerLabel: string;
  readonly preview: string;
}

export interface RecordTabData {
  readonly dialogues: readonly RecordDialogueCardData[];
}

export interface DialoguePresentationOptions {
  readonly translate?: (key: string) => string;
  readonly lines?: readonly DialogueLine[];
}

export function buildRecordTabData(
  seenIds: readonly string[],
  opts: DialoguePresentationOptions = {},
): RecordTabData {
  const translate = opts.translate ?? t;
  const lines = opts.lines ?? DIALOGUE_LINES;
  const seen = new Set(seenIds);
  return {
    dialogues: allDialogueIds(lines)
      .filter((dialogueId) => seen.has(dialogueId))
      .map((dialogueId) => {
        const dialogueLines = dialogueLinesById(dialogueId, lines);
        const first = dialogueLines[0];
        return {
          dialogueId,
          title: first ? translate(first.speakerKey) : dialogueId,
          triggerLabel: first ? translate(`record.trigger.${first.trigger}`) : dialogueId,
          preview: first ? translate(first.textKey) : dialogueId,
        };
      }),
  };
}

export function buildBattleDialoguePresentation(
  dialogueId: string,
  opts: DialoguePresentationOptions & { readonly unread?: boolean } = {},
): BattleDialogueData | null {
  const translate = opts.translate ?? t;
  const lines = dialogueLinesById(dialogueId, opts.lines ?? DIALOGUE_LINES);
  if (lines.length === 0) return null;
  return {
    dialogueId,
    unread: opts.unread ?? false,
    lines: lines.map((line) => ({
      speaker: translate(line.speakerKey),
      text: translate(line.textKey),
    })),
  };
}
